import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import {
  AUTH0_AUDIENCE,
  AUTH0_CLIENT_ID,
  AUTH0_DOMAIN,
  getAuth0RedirectUri,
} from "./config";

/** When env is incomplete, callers should not wrap with this provider. */
export default function Auth0ProviderWithNavigate({ children }) {
  const navigate = useNavigate();

  return (
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: getAuth0RedirectUri(),
        audience: AUTH0_AUDIENCE,
        scope: "openid profile email offline_access",
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      onRedirectCallback={(appState) => {
        const target =
          typeof appState?.returnTo === "string"
            ? appState.returnTo
            : "/";
        navigate(target, {
          replace: true,
          state:
            typeof appState === "object" && appState !== null ? appState : {},
        });
      }}
    >
      {children}
    </Auth0Provider>
  );
}
